export default __webpack_public_path__ + "static/media/258.c547f29c.gif";